<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-if="port==4"  :to="{ path: '/approvalHome' }">工程审批</el-breadcrumb-item>
            <el-breadcrumb-item v-else  :to="{ path: '/approvalHomeEnt' }">工程审批</el-breadcrumb-item>
            <el-breadcrumb-item>工程形象进度表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="width: 100px;">工程名称:</span>
                <el-input v-model="search.programmeName" placeholder="请输入工程名称" clearable>
                </el-input>
              </div>
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="width: 110px;">承包商名称:</span>
                <el-input v-model="search.contractorName" placeholder="请输入承包商名称" clearable>
                </el-input>
              </div>
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="width: 100px;">申报人:</span>
                <el-input v-model="search.createBy" placeholder="请输入申报人" clearable>
                  <!-- <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button> -->
                </el-input>
              </div>
              <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
            </div>
            <el-button type="primary" plain icon="el-icon-plus" v-if="buttonShow==1" style="display:flex;align-items:center" @click="add">添加
            </el-button>
            <!-- <el-tooltip class="item" effect="dark" content="导出" placement="top-end" v-if="isMenuExit('pro:record:export')">
                <img  class="icon_hover"  @click="exportWorker" src="../../assets/image/export.png" alt="" srcset="">
             </el-tooltip> -->
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table stripe :data="listData" height="100%" style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}" @filter-change="filterTag" border>
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ (currentPage - 1) * pageSize + scope.$index + 1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="工程名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.programmeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="汇总编号">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="工程形象进度表明细">
                <template slot-scope="scope">
                  <el-button @click="bugDetail(scope.$index, scope.row)" plain type="primary" size="mini">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column label="申报人">
                <template slot-scope="scope">
                  <span>{{ scope.row.createBy }}</span>
                </template>
              </el-table-column>
              <el-table-column label="申报日期">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="审批状态">
                <template slot-scope="scope">
                  <div @click="proccess(scope.$index, scope.row)" style="cursor: pointer;">
                    <div style="color: #f00;" v-if="scope.row.processStatus<=scope.row.processCount">待{{scope.row.unitName}}</div>
                    <div style="color: #f00;" v-if="scope.row.processStatus<=scope.row.processCount">({{scope.row.postName}})审批</div>
                    <span style="color: #1aa034;" v-if="scope.row.processStatus>scope.row.processCount">已完成</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row,2)">详情</el-button>
                  <el-button type="text" v-if="scope.row.isOwn==1 && scope.row.buttonShow==1" size="mini" @click="handleEdit(scope.$index, scope.row,1)">编辑</el-button>
                  <el-button type="text" v-if="scope.row.buttonShow==2" size="mini" @click="check(scope.$index, scope.row)">审核</el-button>
                  <el-button type="text" v-if="scope.row.isOwn==1 && scope.row.buttonShow==1" size="mini" @click="sumbit(scope.$index, scope.row)">提交</el-button>
                  <el-button type="text" v-if="scope.row.isOwn==1 && scope.row.buttonShow==1" size="mini" @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[3, 5, 10, 20]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="totalItems"></el-pagination>
          </div>
          <!-- 新增窗口 -->
          <el-dialog :title="dialogTitle" :visible.sync="addFormVisible" center :append-to-body="true"
            :lock-scroll="false" class="add-form" width="1000px">
            <el-form :model="addForm" ref="addForm" :rules="rules" label-width="160px" :label-position="labelPosition">
              <el-form-item label="工程名称：" prop="programmeName">
                <el-input v-model="addForm.programmeName" :disabled="status==2" autocomplete="off"
                  @input="change($event)" placeholder="请输入工程名称"></el-input>
              </el-form-item>
              <el-form-item label="汇总编号：" prop="orderNumber">
                <el-input  v-model="addForm.orderNumber"  placeholder="请输入编号" :disabled="status==2"   @input="change($event)"
                  autocomplete="off">
                  <!-- <el-button slot="append" @click="createCode">生成编号</el-button> -->
                </el-input>
              </el-form-item>
              <div style="display: flex;justify-content: space-between;border-top: 1px;cursor: pointer;">
                <div>工程形象进度明细:</div>
                <i v-if="status!=2" @click="addMoney()" style="color: #4994fb;" class="el-icon-circle-plus"></i>
              </div>
              <!-- 表格 -->
              <el-table :data="tableData" height="350px" style="width: 100%;font-size: 12px;">
                <el-table-column label="序号" width=80>
                  <template slot-scope="scope">
                    <span>{{scope.$index+1}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="工程名称" prop="createDate">
                  <template slot-scope="scope">
                    <span>{{scope.row.programmeName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="截止本月末累计完成情况" prop="createDate">
                  <template slot-scope="scope">
                    <span>{{scope.row.cumulativeCompleteMonth}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="本月完成情况" prop="createDate">
                  <template slot-scope="scope">
                    <span>{{scope.row.completeMonth}}</span>     
                  </template>        
                </el-table-column>
                <!-- <el-table-column label="监理单位审核说明" prop="createDate">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isSet">{{scope.row.invoiceMoney}}</span>
                    <el-input v-else v-model="master.invoiceMoney" autocomplete="off" placeholder="请输入收款金额："></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="造假咨询单位审核说明" prop="createDate">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isSet">{{scope.row.invoiceMoney}}</span>
                    <el-input v-else v-model="master.invoiceMoney" autocomplete="off" placeholder="请输入收款金额："></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="全过程工程咨询单位审核说明" prop="createDate">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isSet">{{scope.row.invoiceMoney}}</span>
                    <el-input v-else v-model="master.invoiceMoney" autocomplete="off" placeholder="请输入收款金额："></el-input>
                  </template>
                </el-table-column> -->
                <el-table-column label="操作" width=150>
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" v-if="status!=2"   @click="handleSumbit(scope.$index, scope.row)">删除</el-button>
                    <!-- <span
              class="el-tag el-tag--info el-tag--mini"
              style="cursor: pointer; margin-right: 10px;color:#f00"
              @click="handleSumbit(scope.$index, scope.row, true)"
              >取消</span> -->
                  </template>
                </el-table-column>
              </el-table>
              <el-form-item label="附件：" prop="appendix" v-if="status==1||!status">
                <el-upload class="avatar-uploader" :action="uploadUrl" :headers="uploadHead" :data="uploadData"
                  :before-remove="beforeRemove" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                  :show-file-list="false" :on-preview="showFile" ref="upload" :file-list="fileListupload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <!-- <img  v-if="addForm.reportAppendix"  @click="showFile" style="width:50px;cursor: pointer;"  src="../../assets/image/pdf.png" alt="">
        <span v-if="addForm.reportAppendix">{{pdfname}}</span> -->
                <!-- 循環多個文件 -->
                <div v-for="(item,index) in fileList" :key="index"
                  style="width: 100%;display: flex;align-items: center;font-size: 10px;">
                  <img @click="showFile(item.fileUrl)" style="width:25px;cursor: pointer;"
                    src="../../assets/image/fileicon.png" alt="">
                  <span>{{item.pdfname}}</span>
                  <i @click="deletePdf(item,index,fileList,1)" style="color: #f00;margin-left: 20px;cursor: pointer;"
                    class="el-icon-delete"></i>
                </div>
                <!-- <div style="color:#f00;font-size: 12px;">请上传pdf格式</div> -->
              </el-form-item>
              <el-form-item label="附件：" v-if="status==2">
                <!-- <img  @click=showFile style="width:50px;cursor: pointer;" v-if="addForm.reportAppendix"  src="../../assets/image/pdf.png" alt="">
        <span v-else style="color:#f00;font-size: 12px;">暂无</span> -->
                <div v-for="(item,index) in fileList" :key="index"
                  style="width: 100%;display: flex;align-items: center;font-size: 10px;">
                  <img @click="showFile(item.fileUrl)" style="width:25px;cursor: pointer;"
                    src="../../assets/image/fileicon.png" alt="">
                  <span>{{item.pdfname}}</span>
                  <!-- <i @click="deletePdf(item,index)" style="color: #f00;margin-left: 20px;cursor: pointer;" class="el-icon-delete"></i> -->
                </div>
              </el-form-item>
              <el-form-item label="备注:">
                <el-input v-model="addForm.remark" type="textarea" autocomplete="off" placeholder="请输入备注"
                  style="width:90%" maxlength="400" show-word-limit :rows="8" :disabled="status==2" ></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" v-if="status==1 || !status">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 提交批阅内容 -->
          <el-dialog :title="sbumitTitle" :visible.sync="sbumitVisible" center :append-to-body="true"
            :before-close="handleClosesbumit" :lock-scroll="false" width="35%">
            <el-form :model="sbumitForm" ref="sbumitForm" label-width="200px" :label-position="labelPosition">
              <el-form-item label="提交备注:">
                <el-input v-model="sbumitForm.remark" type="textarea" autocomplete="off" placeholder="请输入提交备注"
                  style="width:90%" maxlength="600" show-word-limit :rows="16"></el-input>
              </el-form-item>
              <el-form-item label="附件:">
                <el-upload class="avatar-uploader" :action="uploadUrl" :headers="uploadHead" :data="uploadData"
                  :before-remove="beforeRemove" :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload"
                  :show-file-list="false" :on-preview="showFile" ref="upload1" :file-list="fileListupload1">
                  <!-- <div v-if="pdfUrl"  class="avatar">{{pdfUrl}}</div> -->
                  <i class="el-icon-plus avatar-uploader-icon"></i>

                </el-upload>
                <!-- <img  v-if="addForm.reportAppendix"  @click="showFile" style="width:50px;cursor: pointer;"  src="../../assets/image/pdf.png" alt="">
        <span v-if="addForm.reportAppendix">{{pdfname}}</span> -->
                <!-- 循環多個文件 -->
                <div v-for="(item,index) in fileList1" :key="index"
                  style="width: 100%;display: flex;align-items: center;font-size: 10px;">
                  <img @click="showFile(item.fileUrl)" style="width:25px;cursor: pointer;"
                    src="../../assets/image/fileicon.png" alt="">
                  <span>{{item.pdfname}}</span>
                  <i @click="deletePdf(item,index,fileList1,2)" style="color: #f00;margin-left: 20px;cursor: pointer;"
                    class="el-icon-delete"></i>
                </div>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="sbumitVisible = false">取 消</el-button>
              <el-button type="primary" @click="sbumitAddRow2('sbumitForm')">确 定</el-button>
            </div>
          </el-dialog>
           <!-- 审核弹框 -->
           <el-dialog :title="checkTitle" :visible.sync="checkVisible" center :append-to-body="true"
           :before-close="handleClosecheck" :lock-scroll="false" width="35%">
           <el-form :model="checkForm" ref="checkForm" label-width="200px" :label-position="labelPosition">
            <el-form-item label="审核:">
              <el-radio v-model="checkForm.checkStatus" label="1">通过</el-radio>
              <el-radio v-model="checkForm.checkStatus" label="2">不通过</el-radio>
            </el-form-item>
             <el-form-item label="提交备注:">
               <el-input v-model="checkForm.remark" type="textarea" autocomplete="off" placeholder="请输入提交备注"
                 style="width:90%" maxlength="600" show-word-limit :rows="16"></el-input>
             </el-form-item>
             <el-form-item label="附件:">
               <el-upload class="avatar-uploader" :action="uploadUrl" :headers="uploadHead" :data="uploadData"
                 :before-remove="beforeRemove" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload"
                 :show-file-list="false" :on-preview="showFile" ref="upload2" :file-list="fileListupload2">
                 <!-- <div v-if="pdfUrl"  class="avatar">{{pdfUrl}}</div> -->
                 <i class="el-icon-plus avatar-uploader-icon"></i>

               </el-upload>
               <!-- <img  v-if="addForm.reportAppendix"  @click="showFile" style="width:50px;cursor: pointer;"  src="../../assets/image/pdf.png" alt="">
       <span v-if="addForm.reportAppendix">{{pdfname}}</span> -->
               <!-- 循環多個文件 -->
               <div v-for="(item,index) in fileList2" :key="index"
                 style="width: 100%;display: flex;align-items: center;font-size: 10px;">
                 <img @click="showFile(item.fileUrl)" style="width:25px;cursor: pointer;"
                   src="../../assets/image/fileicon.png" alt="">
                 <span>{{item.pdfname}}</span>
                 <i @click="deletePdf(item,index,fileList2,3)" style="color: #f00;margin-left: 20px;cursor: pointer;"
                   class="el-icon-delete"></i>
               </div>
             </el-form-item>
           </el-form>
           <div slot="footer" class="dialog-footer">
             <el-button @click="checkVisible = false">取 消</el-button>
             <el-button type="primary" @click="checkAddRow2('checkForm')">确 定</el-button>
           </div>
         </el-dialog>
          <!-- 审批流弹框 -->
          <el-dialog :title="processTitle" :visible.sync="processVisible" center :append-to-body="true"
            :before-close="handleCloseprocess" :lock-scroll="false" width="35%" height="700px">
            <div style="height: 350px;overflow: auto;">
              <el-steps direction="vertical">
                <el-step v-for="(item,index) in processList" :key="index" process-status="success">
                  <template slot="description">
                    <div>
                      <div class="stepNoBtn">
                        <div class="step-title-font">处理人:{{ item.createBy }}({{item.unitName}}--{{item.postName}})</div>
                        <div class="step-title-font">处理时间:{{ item.createDate }}</div>
                        <div>处理意见：{{item.remark||'无'}}</div>
                        <div v-if="item.appendix" style="display: flex;align-items: center;">
                          <span>附件：</span>
                          <img @click="showFile(item.appendix)" style="width:25px;cursor: pointer;" src="../../assets/image/fileicon.png" alt="">
                        </div>
                      </div>
                    </div>
                  </template>
                </el-step>
              </el-steps>
            </div>
          </el-dialog>
          <!-- 工程形象进度明细弹框 -->
          <el-dialog title="工程形象进度明细" :visible.sync="dialogTableVisible"  class="tableDialog">
            <el-table :data="gridData"  height="100%" style="width: 100%;">
              <el-table-column property="index" label="序号" width=80></el-table-column>
              <el-table-column property="programmeName" label="工程名称" ></el-table-column>
              <el-table-column property="cumulativeCompleteMonth" label="截止本月末累计完成情况" ></el-table-column>
              <el-table-column property="completeMonth" label="本月完成情况" ></el-table-column>
            </el-table>
          </el-dialog>
           <!-- 添加工程形象进度明细弹框 -->
          <el-dialog :title="projectTitle" :visible.sync="projectVisible" center :append-to-body="true"
          :before-close="handleCloseproject" :lock-scroll="false" width="35%">
          <el-form :model="projectForm" ref="projectForm" label-width="200px" :label-position="labelPosition">
            <el-form-item label="工程名称:">
              <el-input v-model="projectForm.programmeName"  autocomplete="off" placeholder="请输入工程名称"
                style="width:90%">
              </el-input>
            </el-form-item>
            <el-form-item label="截止本月末累计完成情况:">
              <el-input v-model="projectForm.cumulativeCompleteMonth" type="textarea" autocomplete="off" placeholder="请输入截止本月末累计完成情况"
                style="width:90%" maxlength="100" show-word-limit :rows="4">
              </el-input>
            </el-form-item>

            <el-form-item label="本月完成情况:">
              <el-input v-model="projectForm.completeMonth" type="textarea" autocomplete="off" placeholder="请输入本月完成情况"
                style="width:90%" maxlength="100" show-word-limit :rows="4">
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="监理单位审核说明:">
              <el-input v-model="projectForm.processRemark" type="textarea" autocomplete="off" placeholder="请输入提交备注"
                style="width:90%" maxlength="100" show-word-limit :rows="4">
              </el-input>
            </el-form-item>
            <el-form-item label="造价咨询单位审核说明:">
              <el-input v-model="projectForm.processRemark" type="textarea" autocomplete="off" placeholder="请输入提交备注"
                style="width:90%" maxlength="100" show-word-limit :rows="4">
              </el-input>
            </el-form-item>
            <el-form-item label="全过程工程咨询单位审核说明:">
              <el-input v-model="projectForm.processRemark" type="textarea" autocomplete="off" placeholder="请输入提交备注"
                style="width:90%" maxlength="100" show-word-limit :rows="4">
              </el-input>
            </el-form-item> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="projectVisible = false">取 消</el-button>
            <el-button type="primary" @click="projectAddRow('projectForm')">确 定</el-button>
          </div>
        </el-dialog>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import myHttp from '../../untils/port.js'
  import util from '../../untils/util.js'
  import base from '../../untils/base'
  export default {
    data() {
      return {
        search: {
          //查询
          programmeName: '',
          contractorName:'',
          projectId: '',
          createBy: '',
        },
        listData: [], //表格数据
        dataText: '数据加载中...',
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                picker.$emit('pick', new Date())
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24)
                picker.$emit('pick', date)
              }
            },
            {
              text: '一周前',
              onClick(picker) {
                const date = new Date()
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', date)
              }
            }
          ]
        },
        attendType: [],
        addFormVisible: false,
        addForm: {
          imageId:'',
          programmeName:'',
          orderNumber:'',
          remark:'',
          appendix:'',
          spipdList:[]
          // projectResponsible:'',
        },
        dialogTitle: '',
        fileList: [],
        fileList1: [],
        fileList2: [],
        fileListupload: [],
        fileListupload1: [],
        fileListupload2: [],
        uploadUrl: base.url + '/upload/uploadFile', //上传地址
        uploadData: {
          type: '247',
          projectId:''
        },
        uploadHead: {
          //上传接口header
          accessToken: this.$store.state.token
        },
        rules: {
          // contractPrice: [{ required: true, message: '请输入合同价格', trigger: 'blur' }],
          // orderNumber: [{ required: true, message: '请输入单号', trigger: 'blur' }],
          // projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
          // projectAddress: [{ required: true, message: '请输入项目地址', trigger: 'blur' }],
          // purchaseType: [{ required: true, message: '请选择发票', trigger: 'change' }],
          // jiaContact: [{ required: true, validator: checkphone, trigger: 'blur' }] //validator: checkphone是验证手机的引入checkphone函数
        },
        labelPosition: 'right',
        status: '',
        sbumitTitle: '提交',
        sbumitVisible: false,
        sbumitForm: {
          linkId:'',
          remark:'',
        },
        checkTitle: '审核',
        checkVisible: false,
        checkForm: {
          linkId:'',
          checkStatus:'',
          remark:'',
        },
        processTitle:'审批流程',
        processVisible:false,
        processForm:{
         
        },
        processList:[],
        processStatus:'',
        processType:'',
        dialogTableVisible:false,
        gridData:[],
        projectTitle:'添加',
        projectForm:{
          cumulativeCompleteMonth:'',
          programmeName:'',
          completeMonth:'',
  
        },
        projectVisible:false,
        tableData:[],
        buttonShow:'',
        port:''
        // types:[],//进出类型
      }
    },
    created() {
      if (util.session.get('roleId') == '4') {
        this.search.projectId = util.session.get('groupId')
      } else {
        this.search.projectId = util.session.get('proId')
      }
    },
    mounted() {
      //this.search.projectId = util.session.get('groupId')
      // if (this.search.projectId == '') {
      //   this.$store.commit('setGroupId')
      //   this.search.projectId = this.$store.state.groupId
      // }
      // console.log(this.search.projectId)
      if (util.session.get('roleId') == '4') {
        this.search.projectId = util.session.get('groupId')
      } else {
        this.search.projectId = util.session.get('proId')
      }
      this.uploadData.projectId = this.search.projectId
      // this.getDict() //获取考勤
      var param = this.$route.params
      this.processType = param.type
      this.port = util.session.get('roleId')
      this.getData()
      this.getNowadd()
    },
    methods: {
      //
      getDict() {
        var that = this
        myHttp
          .getDictByType({
            type: 'attend_type'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.dictList || []
              for (var i = 0; i < list.length; i++) {
                list[i].text = list[i].label
              }
              that.attendType = list
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      //获取类型
      filterSatus(str) {
        var list = this.attendType
        var result = ''
        for (var i = 0; i < list.length; i++) {
          if (str == list[i].value) {
            result = list[i].label
          }
        }
        return result
      },
      // 搜索数据
      doFilter() {
        // this.search.startDate = this.date ? this.date[0] : ''
        // this.search.endDate = this.date ? this.date[1] : ''
        this.currentPage = 1
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      //监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      // 获取数据
      getData() {
        var that = this
        this.search.pageNum = this.currentPage
        this.search.pageSize = this.pageSize
        myHttp.findSpProgrammeImageProcessList(this.search).then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''
                list[i].typeName = that.filterSatus(list[i].status)
                // list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto!=''?base.httpCtx+list[i].idcardPhoto:''
                // list[i].createDate = list[i].createDate && list[i].createDate!=''?list[i].createDate.split(' ')[0]:''
                // list[i].age = util.myTime.getAge(list[i].birthday)
              }
              that.listData = list
              that.totalItems = resp.data.data.total || 0
              //that.getTypeName()
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () { }
        )
      },
      add() {
        this.addFormVisible = true
        this.status = ''
        this.dialogTitle = '添加'
        this.fileList = []
        this.tableData = []
        this.addForm = {
          imageId:'',
          programmeName:'',
          orderNumber:'',
          remark:'',
          appendix:'',
          spipdList:[]
        }
        this.$nextTick(()=>{
          this.$refs.upload.clearFiles()
       });    
      },
        //编辑
        handleEdit(index, row,status) {
         this.status = status
        this.fileList = []
        this.$nextTick(()=>{
          this.$refs.upload.clearFiles()
       });
        // this.pdfUrl=''
        this.addFormVisible = true
        this.dialogTitle =status==1? '修改':'详情'
        var that = this
        myHttp.detailSpProgrammeImageProcess({
          imageId: row.imageId
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var data = resp.data.data
            // console.log(data)
            that.addForm.imageId = data.imageId
            that.addForm.orderNumber = data.orderNumber
            that.addForm.programmeName = data.programmeName
            that.addForm.remark = data.remark
            
            // that.addForm.copyUnit = data.copyUnit
            // that.addForm.executiveUnit = data.executiveUnit
            // that.addForm.copyUnit = data.copyUnit
            that.addForm.spvtdList = data.spProgrammeImageProcessDetailList
            that.tableData = data.spProgrammeImageProcessDetailList
            // that.addForm.copyUnit = data.copyUnit
            // that.addForm.executiveUnit = data.executiveUnit
            // that.addForm.copyUnit = data.copyUnit
            that.addForm.appendix = data.appendix
            // this.addForm.projectResponsible = data.projectResponsible
            // if(that.addForm.contractAppendix ){
            //   // that.addForm.contractAppendix = data.contractAppendix
            //   let nameArr = that.addForm.contractAppendix.split('/')
            //   let name = nameArr[nameArr.length-1]
            //   that.pdfname = name
            // }
            // let arr =  []
            // arr =   that.addForm.contractAppendix.split(',')
            // for(let i = 0;i<arr.length;i++){
            //   arr[i].nameArr = arr[i].split('/')
            //   arr[i].pdfname = arr[i].nameArr[arr[i].nameArr -1]

            //   // arr[i]["pdfname"] = arr[i]
            // }
            if( that.addForm.appendix){
              let array = [];
              let list = that.addForm.appendix.split(',')
              // console.log(list)
              list.map((item, index) => {
                array.push(
                  Object.assign({}, { fileUrl: item })
                )
              });
              if (array.length != 0) {
                for (var i = 0; i < array.length; i++) {
                  // array[i].response.data.fileUrl = array[i].fileUrl 
                  array[i].nameArr = array[i].fileUrl.split('/')
                  array[i].pdfname = array[i].nameArr[array[i].nameArr.length - 1]
                }
              }
              console.log(array)
              that.fileList = array
            }
            
          }
        })
      },
      // watchInput(e) {
      //   this.search.personName = e
      //   this.getData()
      // }
      handleSumbit(index,row){
        var that = this
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.tableData.splice(index,1);
          that.$message.success('删除汇总明细成功')
        }).catch(err => {
        })
      },
     
      projectAddRow(formName){
        var that = this
        this.tableData.push(this.projectForm)
        this.$message.success('添加汇总明细成功')
        this.projectVisible = false
        console.log(this.tableData)
      },
      personInfo(index, row) {
        var port = util.session.get('roleId')
        if (port == '4') {
          this.$router.push({ name: 'workerInfo', params: { id: row.personId } })
        } else if (port == '5' || port == '3') {
          this.$router.push({ name: 'workerInfoCom', params: { id: row.personId } })
        }

      },
      /**
       * 判断是否展示
       */
      isMenuExit(row) {
        var flag = util.common.filterBtnMenu(row)
        return flag
      },

      filterTag(filters) {
        // console.log(filters)
        this.search.status = filters.aStatus[0]
        this.getData()
      },
      showFile(file) {
        // console.log(this.addForm.reportAppendix)
        window.open(base.httpCtx + file)
      },
  
      beforeAvatarUpload(file) {

        const isPDF = file.type === 'application/pdf';
        // const isLt2M = file.size / 1024 / 1024 < 2;
        console.log(file.type)
        // if (!isPDF) {
        //   this.$message.error('附件只能是 pdf 格式!');
        // } else {
          this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        // }
        // if (!isLt2M) {
        //   this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        // return isPDF;
      },
      beforeRemove(file, fileList) {
        var that = this
        // return this.$confirm(`确定移除 ${ file.name }？` ,{
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() =>{
        //   console.log(that.fileList)
        // });
      },
      handleAvatarSuccess(res, file, fileList) {
        // console.log(fileList)
        // this.fileList = []
        this.$forceUpdate();
        if (res.code == '200') {
          this.$message.success(res.msg)
          this.loading.close();
          if (fileList.length != 0) {
            for (var i = 0; i < fileList.length; i++) {
              fileList[i].fileUrl = fileList[i].response.data.fileUrl
              fileList[i].nameArr = fileList[i].response.data.fileUrl.split('/')
              fileList[i].pdfname = fileList[i].nameArr[fileList[i].nameArr.length - 1]
            }
          }
          if (this.dialogTitle == '添加') {
            this.fileList = fileList
          } else {
            this.fileList = this.fileList.concat(fileList)
          }

          console.log(this.fileList)
        } else {
          // this.loading.close()
          this.$message.error(res.msg)
        }
      },
      // 提交附件
      handleAvatarSuccess1(res, file, fileList) {
        // console.log(fileList)
        // this.fileList = []
        this.$forceUpdate();
        if (res.code == '200') {
          this.$message.success(res.msg)
          this.loading.close();
          if (fileList.length != 0) {
            for (var i = 0; i < fileList.length; i++) {
              fileList[i].fileUrl = fileList[i].response.data.fileUrl
              fileList[i].nameArr = fileList[i].response.data.fileUrl.split('/')
              fileList[i].pdfname = fileList[i].nameArr[fileList[i].nameArr.length - 1]
            }
          }
          this.fileList1 = fileList
          console.log(this.fileList1)
        } else {
          // this.loading.close()
          this.$message.error(res.msg)
        }

      },
      //审批附件
      handleAvatarSuccess2(res, file, fileList) {
        // console.log(fileList)
        // this.fileList = []
        this.$forceUpdate();
        if (res.code == '200') {
          this.$message.success(res.msg)
          this.loading.close();
          if (fileList.length != 0) {
            for (var i = 0; i < fileList.length; i++) {
              fileList[i].fileUrl = fileList[i].response.data.fileUrl
              fileList[i].nameArr = fileList[i].response.data.fileUrl.split('/')
              fileList[i].pdfname = fileList[i].nameArr[fileList[i].nameArr.length - 1]
            }
          }
          this.fileList2 = fileList
          console.log(this.fileList2)
        } else {
          // this.loading.close()
          this.$message.error(res.msg)
        }

      },
      // 编辑
      editInfo() {
        this.addFormVisible = true
      },
      //删除
      deleteInfo(index, row) {
        var that = this;
        // var multipleSelection = this.multipleSelection
        // if (multipleSelection.length == '0') {
        //   that.$message({
        //     type: 'warning',
        //     message: '请选择需要删除的数据!'
        //   })
        //   return
        // }

        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteSpProgrammeImageProcess({
            imageId: row.imageId
          }).then(function (resp) {
            if (resp.data.code == "200") {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getData();
            } else {
              that.$message.error(resp.data.msg);
            }
          }, function () { });
        }).catch(err => {
        })
      },
      sumbitAddRow(formName) {
        var that = this
        var picUrls = []
        this.addForm.projectId = this.search.projectId
        for (var i = 0; i < this.fileList.length; i++) {
          picUrls.push(this.fileList[i].fileUrl)
        }
        this.addForm.appendix = picUrls.toString()
        this.addForm.spipdList = JSON.stringify(this.tableData)  
        console.log(this.addForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (that.addForm.imageId == "") {
              myHttp.addSpProgrammeImageProcess(this.addForm).then(function (resp) {
                if (resp.data.code == "200") {
                  that.$message.success("添加成功");
                  that.addFormVisible = false;
                  that.currentPage = 1;
                  that.getData();
                } else {
                  that.$message.error(resp.data.msg);
                }
              }, function () { });
            } else {
              // that.addForm.contractAppendix = that.pdfUrl
              myHttp.editSpProgrammeImageProcess(this.addForm).then(function (resp) {
                if (resp.data.code == "200") {
                  that.$message.success("修改成功");
                  that.addFormVisible = false;
                  that.getData();
                } else {
                  that.$message.error(resp.data.msg);
                }
              }, function () { });
            }
          }
        });
      },   
      // 确定提交
      sbumitAddRow2(formName) {
        var that = this
        var picUrls = []
        var that = this
        if(this.fileList1.length>0){
          for (var i = 0; i < this.fileList1.length; i++) {
          picUrls.push(this.fileList1[i].response.data.fileUrl)
          }
           this.sbumitForm.appendix = picUrls.toString()
        }
        
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.sbumitForm.processType = this.processType
            // this.sbumitForm.processStatus =this.processStatus
            this.sbumitForm.projectId =this.search.projectId
            myHttp.submitSpTableLink(this.sbumitForm).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success(resp.data.msg);
                that.sbumitVisible = false
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            }, function () { });
          }
        });
      }, 

      checkAddRow2(formName){
        var that = this
        var picUrls = []
        var that = this
        if(this.fileList2.length>0){
          for (var i = 0; i < this.fileList2.length; i++) {
          picUrls.push(this.fileList2[i].response.data.fileUrl)
          }
           this.checkForm.appendix = picUrls.toString()
        }
        
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.checkForm.processType = this.processType
            // this.sbumitForm.processStatus =this.processStatus
            this.checkForm.projectId =this.search.projectId
            myHttp.checkSpTableLink(this.checkForm).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success(resp.data.msg);
                that.checkVisible = false
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            }, function () { });
          }
        });
      },

       // 删除文件
       deletePdf(item,index,fileList,type){
            console.log(item,index,fileList)
            return this.$confirm(`确定移除 ${ item.pdfname }？` ,{
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() =>{
              fileList.splice(index,1);
              switch  (type){
                case  1:
                this.fileList = fileList
                case  2:
                this.fileList1 = fileList
                case  3:
                this.fileList2 = fileList 
}
             });
       },    
      bugDetail(index,row){
        this.dialogTableVisible = true  
        this.getInfo(row.imageId)
      },
      getInfo(imageId){
        var that = this
        myHttp.findSpProgrammeImageProcessDetail({
          imageId:imageId
        }).then(function (resp) {
            if (resp.data.code == "200") {  
            var list = resp.data.data
            list.forEach((element,index) => {
              element.index = index +1  
            });
            that.gridData = list
              // console.log( that.gridData)
            } else {
              that.$message.error(resp.data.msg);
            }
          }, function () { });
      },

      sumbit(index, row) {
        var that = this;
        this.sbumitForm.remark = ''
        this.fileList1 = []
        this.sbumitForm.linkId = row.imageId
        this.sbumitForm.processStatus = row.processStatus
        this.sbumitVisible = true
        this.$nextTick(()=>{
          this.$refs.upload1.clearFiles()
       });

      },
      check(index, row) {
        var that = this;
        this.fileList2 = []
        this.checkForm.checkStatus = ''
        this.checkForm.remark = ''
        this.checkForm.linkId = row.imageId
        this.checkForm.processStatus = row.processStatus
        this.checkVisible = true
        this.$nextTick(()=>{
          this.$refs.upload2.clearFiles()
       });  

      },
      proccess(index, row) {
        this.processVisible = true
        this.processForm.linkId = row.imageId
        this.processForm.processType = this.processType
        this.processForm.projectId  = this.search.projectId
        this.getProcess()
      },
      //获取流程
      getProcess(){
        var that = this
        myHttp.findSpTableLinkRecord(this.processForm).then(function (resp) {
            if (resp.data.code == "200") {
              var list =  resp.data.data
              that.processList = list
            } else {
              that.$message.error(resp.data.msg);
            }
          }, function () { });
      },
      addMoney(){
        this.projectVisible = true
        this.projectForm ={
          programmeName:'',
          cumulativeCompleteMonth:'',
          completeMonth:'',
        }       
      },
      // 查询当前账号添加审批单权限
      getNowadd() {
        var that = this
        // console.log(processStatus)
        myHttp.findPowerProcessAdd({
          // processStatus: processStatus,
          processType: this.processType
        }).then(function (resp) {
          if (resp.data.code == '200') {
            // console.log(resp)
            that.buttonShow = resp.data.data.buttonShow
            // console.log(that.buttonShow)
          }
        })
      },
      handleClosereason() {
        this.$forceUpdate()
        this.reasonVisible = false
      },
      handleClosesbumit(){
        this.sbumitVisible = false
      },
      handleCloseback() {
        this.backVisible = false
      },
      handleCloseprocess(){
        this.processVisible = false
      },
      handleClosecheck(){
        this.checkVisible = false
      },
      handleCloseproject(){
        this.projectVisible = false
      }
    }
  }
</script>
<style>
  @import '../../assets/css/common.css';
</style>
<style scoped>
  .content>>>.el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }

  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }

  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .search-section {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 20px 35px 20px 10px;
    height: 40px;
    justify-content: space-between;
  }

  .el-end {
    height: 47px;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;
  }

  .build-table {
    height: calc(100% - 127px);
    width: 98%;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .el-pagination {
    margin: auto;
  }

  .el-table--fit {
    border-bottom: 1px solid #f5f5f5;
  }

  .content>>>.el-input-group--append .el-input__inner {
    width: 200px;
  }
  .stepNoBtn{
    color:#303133;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }    
  .tableDialog >>>.el-dialog__body{
    height: 400px;
  }
</style>